<template>
  <v-container
    grid-list-xs
    class="d-flex flex-column justify-center align-center py-16 fill-height"
  >
    <v-card class="card-width card-radius card-shadow" elevation="0">
      <v-card-title
        primary-title
        class="dark-blue white--text title font-weight-medium px-10"
        >Informasi</v-card-title
      >

      <v-container grid-list-xs class="py-5">
        <v-col v-for="info in informations" :key="info.url">
          <v-card v-if="info.url != 'pengumuman-seleksi'" class="card-radius card-shadow py-3 px-8" elevation="0" :to="`informasi/${info.url}`">
            <v-row align="center">
              <div class="icon-radius pa-3 pink-color mr-5 hidden-sm-and-down">
                <v-icon size="40">{{ info.icon }}</v-icon>
              </div>
              <div class="card-text font-weight-medium">{{ info.text }}</div>
              <v-spacer></v-spacer>
              <v-icon>mdi-chevron-right</v-icon>
            </v-row>
          </v-card>
          <v-card v-else class="card-radius card-shadow py-3 px-8" elevation="0" :href="`https://dev-api-ppdb.smkruskudus.com/preview/${id}?type=PENGUMUMAN`">
            <v-row align="center">
              <div class="icon-radius pa-3 pink-color mr-5 hidden-sm-and-down">
                <v-icon size="40">{{ info.icon }}</v-icon>
              </div>
              <div class="card-text font-weight-medium">{{ info.text }}</div>
              <v-spacer></v-spacer>
              <v-icon>mdi-chevron-right</v-icon>
            </v-row>
          </v-card>
        </v-col>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  data: () => ({
    informations: [
      {
        text: "Syarat Pendaftaran",
        url: "syarat-pendaftaran",
        icon: "mdi-file-document",
      },
      {
        text: "Berkas Pendaftaran",
        url: "berkas-pendaftaran",
        icon: "mdi-package",
      },
      {
        text: "Rincian Pembayaran",
        url: "rincian-pembayaran",
        icon: "mdi-receipt",
      },
      { text: "Informasi Program Keahlian", url: "jurusan", icon: "mdi-school" },
    ],
    id: "",
  }),
  mounted() {
    this.id = localStorage.getItem("id");

    // this.checkIsOpenWave();

    if (!this.id || !localStorage.getItem("hasRegister")) return;

    this.checkStudent();
  },
  methods: {
    checkIsOpenWave() {
      moment.locale("id");

      const currentTime = moment(localStorage.getItem("date"));

      const currentWave = this.$date.filter((itemDate) => {
        const range = moment().range(
          moment(itemDate.open),
          moment(itemDate.result)
        );
        return range.contains(currentTime);
      });

      if (currentWave.length > 0) {
        this.informations.push({
          text: "Tes Masuk",
          url: "tes-masuk",
          icon: "mdi-pencil"
        });
      }
    },

    async checkStudent() {
      EventBus.$emit("startLoading");

      const res = await axios.get(`${this.$api}/profile?id=${this.id}`);
      const status = res.data.PAYLOAD.sw_status;

      // Alur registrasi udah sepaket sama pdf pengumuman
      // if (localStorage.getItem("hasCekPengumuman") === localStorage.getItem("id") && status === 9) {
      //   this.informations.unshift({
      //     text: "Alur Daftar Ulang",
      //     url: "alur-registrasi",
      //   });
      // }

      if (
        localStorage.getItem("hasCekPengumuman") ===
          localStorage.getItem("id") &&
        (status === 8 || status === 9 || status === 10 || status == 11)
      ) {
        this.informations.unshift({
          text: "Pengumuman Seleksi",
          url: "pengumuman-seleksi",
          icon: "mdi-email-open"
        });
      }

      if (res.data.STATUS != "SUCCES") return EventBus.$emit("stopLoading");
      if (status < 8) return EventBus.$emit("stopLoading");

      moment.locale("id");
      const currentTime = moment(localStorage.getItem("date"));
      const isAfterResult = this.$date.filter((itemDate) => {
        return moment(currentTime).isAfter(itemDate.result);
      });
      EventBus.$emit("stopLoading");
    },
  },
};
</script>

<style scoped>
.card-width {
  width: 70%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08)!important;
}

.pink-color {
  background-color: #fec0a0;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.icon-radius {
  border-radius: 7px !important;
}

.dark-blue {
  background-color: #24305e !important;
}

.info-section {
  min-height: 80vh;
}

.card-wrapper {
  margin: 100px 0;
  width: 70%;
}

.inbox-card {
  border-left: 8px solid #2a429e;
}

.a-link {
  text-decoration: none;
  color: #2a429e;
}

.a-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 90%;
  }

  .card-text {
    font-size: 1rem;
  }
}
</style>